import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions, selectors } from "redux-store";
import { GameStatus } from "redux-store/slices/game/game.interfaces";

export const useTile = (index: number) => {
  const dispatch = useDispatch();

  const { tiles } = useSelector(selectors.getChosenLevel);
  const { turns, canRotate } = useSelector(selectors.getTileRotation(index));
  const status = useSelector(selectors.getGameStatus);

  const imgPath = useMemo(() => tiles[index], [tiles, index]);

  const cursor = useMemo(() => {
    if (canRotate) {
      return status === GameStatus.PLAYING ? "pointer" : "unset";
    } else return "not-allowed";
  }, [status, canRotate]);
  const transform = useMemo(() => `rotate(${90 * turns}deg)`, [turns]);

  const onTileClicked = useCallback(() => {
    if (status === GameStatus.PLAYING && canRotate) {
      dispatch(actions.rotateTile(index));
      dispatch(actions.playSound("swooshAudioId"));
      dispatch(actions.incrementMovesCount());
    }
  }, [canRotate, index, status, dispatch]);

  return {
    onTileClicked,
    imgPath,
    cursor,
    transform,
  };
};
